import { render } from "./DomainInstructions.vue?vue&type=template&id=37b4f9eb&scoped=true"
import script from "./DomainInstructions.vue?vue&type=script&lang=ts"
export * from "./DomainInstructions.vue?vue&type=script&lang=ts"

import "./DomainInstructions.vue?vue&type=style&index=0&id=37b4f9eb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-37b4f9eb"

export default script